import { Component, OnInit, Renderer2 } from '@angular/core';
import { PatientMedicationModel, DeleteMedication, Medications, FamilyHistory, MedicationsPhoto } from 'src/app/models/intake/intakeMedication';
import { IntakeMedicationService } from 'src/app/services/intake-Medication.service';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { IntakeAllergyService } from 'src/app/services/intake-Allergy.service';
import { IntakeService } from 'src/app/services/intake.service';
import { Router } from '@angular/router';
import { IntakeFieldsSetting } from 'src/app/models/intake/intakeAllergies';
import { TranslateService } from '@ngx-translate/core';
import { getMedication } from 'src/app/models/intake/intakeMedication';
import { CommonDiseaseResponse } from 'src/app/models/intake/familyHistory';
import { FamilyHistoryService } from '../../../services/family-history.service';
import { SearchPatientPharmacyModel, Getpharmacies } from '../../../models/updatepersonalinfo/updatepersonalinfo';
import { UpdateinfoService } from 'src/app/services/updateinfo.service'
import { getPatientDataByURl, PatientPersonalInfo } from 'src/app/models/verifypatient/verifypatient';
declare var $: any;
var objectCopyDiagnosis: any;
var objectCopyMedication: any;
@Component({
  selector: 'app-medication',
  templateUrl: './medication.component.html',
  styleUrls: ['./medication.component.css']
})
export class MedicationComponent implements OnInit {

  objPatientMedication: PatientMedicationModel[] = [];
  SearchPatientPharmacyModel: SearchPatientPharmacyModel;
  Getpharmacies: any = [];
  patientpersonalinfo: PatientPersonalInfo;
  isLoadingPM = true;
  isLoading = false;
  filteredMedications: any;
  medicError: string;
  readonly notSpecified = "Not Specified";
  readonly operationEdit = "EDIT";
  readonly operationAdd = "ADD";
  readonly _IP_Address = "127.0.0.1";
  readonly componentName = "Intake Form";
  operationPerformed = "";
  familyHistoryModel: FamilyHistory = new FamilyHistory();
  intakeFieldsSetting: IntakeFieldsSetting = new IntakeFieldsSetting();
  selected_objPatientMedication: PatientMedicationModel = new PatientMedicationModel();
  NoKnownHistory: any;
  medicationaction: any = "Add";
  imageChangedEvent: any;
  addNewMedication: boolean = true;
  addNewMedicationManually: boolean = false;
  FDToken: any = "";
  isFDServiceDataComing: boolean = true;
  newPatientPersonalInfo: getPatientDataByURl;
  landFromCheckin: any;
  isFromNewPatient: boolean = false;
  reasonName: any;
  PracticeCode: any;
  PatientAccount: any;
  ZIP: any;
  STATE: any;
  CITY: any;
  ProviderCode: any;
  constructor(private renderer: Renderer2, private translateService: TranslateService, private _intakeMedicationService: IntakeMedicationService, private _phrutilService: PhrutillsService, private spinner: NgxSpinnerService,
    private _intakedAllergyService: IntakeAllergyService, private phrUtils: PhrutillsService, private _intakeser: IntakeService, private router: Router, private service: FamilyHistoryService, private UpdateinfoService: UpdateinfoService) {
    this.SearchPatientPharmacyModel = new SearchPatientPharmacyModel;
    let checkinFrom = localStorage.getItem('landFrom');
    console.log("checkinFrom chk", checkinFrom);
    if (checkinFrom == 'drsiteintake' || checkinFrom == 'new_patient') {
      let info = localStorage.getItem('PatientInfo');
      if (!info) {
        this.router.navigateByUrl("/");
        return;
      }
      console.log("info in intake form PatientInfo", info);
      this.newPatientPersonalInfo = this.phrUtils.decrypt(info) as getPatientDataByURl;
      console.log("newPatientPersonalInfo in intake form", this.newPatientPersonalInfo);
      this.reasonName = this.newPatientPersonalInfo.reasonName;
      this.PracticeCode = this.newPatientPersonalInfo.practiceCode;
      this.PatientAccount = this.newPatientPersonalInfo.patientAccount;
      this.ZIP = this.newPatientPersonalInfo.praticeZip;
      this.STATE = this.newPatientPersonalInfo.practiceState;
      this.CITY = this.newPatientPersonalInfo.PracticeCity;
      this.ProviderCode = this.newPatientPersonalInfo.providerCode;
    }

    else {
      let info = localStorage.getItem('PersonalInfo');
      if (!info) {
        this.router.navigateByUrl("/");
        return;
      }
      this.patientpersonalinfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
      console.log("patientpersonalinfo in intake form", this.patientpersonalinfo);
     // this.reasonName = this.patientpersonalinfo.REASON_NAME;
      this.PracticeCode = this.patientpersonalinfo.PRACTICE_CODE;
      this.PatientAccount = this.patientpersonalinfo.PATIENT_ACCOUNT;
      this.ZIP = this.patientpersonalinfo.ZIP;
      this.STATE = this.patientpersonalinfo.STATE;
      this.CITY = this.patientpersonalinfo.CITY;
      this.ProviderCode = this.patientpersonalinfo.PROVIDER_CODE;
    }
  }

  ngOnInit(): void {
    this.getmedicationToken();
    this._phrutilService.patientlanguage$.subscribe(language => {
      console.log("dafault " + language);
      if (language === 'es') {
        this._phrutilService.setTitle('Medicamentos');
      } else if (language === 'hi') {
        this._phrutilService.setTitle('दवाइयाँ');
      }
      else if (language === 'ur') {
        this._phrutilService.setTitle(' ادویات');
      }
      else {
        this._phrutilService.setTitle('Medications');
      }
    });

    //this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PersonalInfo'));
    this.GetNoKnownHistory();
    this.onPatientMedication();
    this.GetPatientPharmacies(this.PatientAccount, this.PracticeCode);
    this.translateService.get('button.add').subscribe((translation: string) => {
      this.medicationaction = translation;
    });
  }

  getmedicationToken() {
    try {
      this._intakeMedicationService.GetTokenForMedication()

        .subscribe(
          (response: any) => {
            //console.log('API response:', response);
            this.FDToken = response.access_token; // Adjust this based on your response structure
            //console.log('Extracted token:', this.FDToken);
            localStorage.setItem("medToken", this.FDToken);
          },
          (error) => {
            console.error('Error:', error);
          }
        );

    } catch (error) {
      console.log("FD service failed, not getting token");
    }

  }

  clearMedicineSearchInput() {
    this.selected_objPatientMedication.medicineName = ''; // Clear the text field
    this.filteredMedications = [];
  }

  clearDiagnosisInput() {
    this.selected_objPatientMedication.diagnosis = '';
  }

  photos: FileList;
  previewUrls: string[] = [];
  uploadStatus: string;
  uploadPhotoObj: any[] = [];


  // pharmacy code
  totalPharmacyRecord: any = 0;
  GetPatientPharmacies(PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {
    this.spinner.show();
    this.UpdateinfoService.GetPatientPharmacies(PATIENT_ACCOUNT, PRACTICE_CODE).subscribe((res: any) => {
      this.spinner.hide();
      this.Getpharmacies = res.RESPONSE as Getpharmacies[];
      this.Getpharmacies.map((item: Getpharmacies) => {
        item.PHARMACY_PHONE = item.PHARMACY_PHONE ? this._phrutilService.maskingPhoneNumer(item.PHARMACY_PHONE) : '';
      });
      this.totalPharmacyRecord = this.Getpharmacies?.length;
      console.log("total pharmacy", this.totalPharmacyRecord);
      if (this.totalPharmacyRecord == 0) {
        localStorage.setItem("tpharmacy", "no");
      } else {
        localStorage.setItem("tpharmacy", "yes");
      }


    }, (error: any) => {
      this.spinner.hide();
    })
  }
  checPharmacyName: any = [];
  pharmaciesSearch: any;
  SetPharmaciesList(pharmacy: any) {


    this.checPharmacyName = [];
    let ss = pharmacy.pharmacyCode;
    this.checPharmacyName = this.Getpharmacies.filter((e: any) => e.PHARMACY_CODE == ss);
    if (this.checPharmacyName?.length > 0) {
      this.pharmaciesSearch = '';
      let text = "Selected pharmacy already exists, please try again";
      this.translateService.get('Alerts.pharmacy_already_exist').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showInfo(text)
      //this._phrutilService.showInfo("Selected pharmacy already exists, please try again");
      return false;
    }
    let tt = this.totalPharmacyRecord + 1;
    if (tt > 3) {
      this.pharmaciesSearch = '';
      let text = "Maximum three pharmacies can be added";
      this.translateService.get('Alerts.maximum_pharmacy').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showInfo(text)
      //this._phrutilService.showInfo("Maximum three pharmacies can be added");
      return false;
    } else {
      let Getpharmaciesdummy = new Getpharmacies();
      if (!this.Getpharmacies[0]) {
        Getpharmaciesdummy.PHARMACY_CODE = pharmacy.pharmacyCode;
        Getpharmaciesdummy.PHARMACY_NAME = pharmacy.pharmacyName;
        Getpharmaciesdummy.PHARMACY_ADDRESS = pharmacy.pharmacyAddress;
        Getpharmaciesdummy.PHARMACY_STATE = pharmacy.pharmacyState;
        Getpharmaciesdummy.PHARMACY_ZIP = pharmacy.pharmacyZip;
        Getpharmaciesdummy.PHARMACY_PHONE = pharmacy.pharmacyPhone;
        this.Getpharmacies.push(Getpharmaciesdummy);
        this.totalPharmacyRecord = this.totalPharmacyRecord + 1;
        this.pharmaciesSearch = '';

      } else if (!this.Getpharmacies[1]) {

        Getpharmaciesdummy.PHARMACY_CODE = pharmacy.pharmacyCode;
        Getpharmaciesdummy.PHARMACY_NAME = pharmacy.pharmacyName;
        Getpharmaciesdummy.PHARMACY_ADDRESS = pharmacy.pharmacyAddress;
        Getpharmaciesdummy.PHARMACY_STATE = pharmacy.pharmacyState;
        Getpharmaciesdummy.PHARMACY_ZIP = pharmacy.pharmacyZip;
        Getpharmaciesdummy.PHARMACY_PHONE = pharmacy.pharmacyPhone;
        this.Getpharmacies.push(Getpharmaciesdummy);
        this.totalPharmacyRecord = this.totalPharmacyRecord + 1;
        this.pharmaciesSearch = '';
      } else if (!this.Getpharmacies[2]) {
        Getpharmaciesdummy.PHARMACY_CODE = pharmacy.pharmacyCode;
        Getpharmaciesdummy.PHARMACY_NAME = pharmacy.pharmacyName;
        Getpharmaciesdummy.PHARMACY_ADDRESS = pharmacy.pharmacyAddress;
        Getpharmaciesdummy.PHARMACY_STATE = pharmacy.pharmacyState;
        Getpharmaciesdummy.PHARMACY_ZIP = pharmacy.pharmacyZip;
        Getpharmaciesdummy.PHARMACY_PHONE = pharmacy.pharmacyPhone;
        this.Getpharmacies.push(Getpharmaciesdummy);
        this.totalPharmacyRecord = this.totalPharmacyRecord + 1;
        this.pharmaciesSearch = '';
      }
    }
    this.AddUpdatePharmacy();
    return true;
  }
  filterSearchPharmaciesList: any;
  isShowplaceholder: any = true;
  dNonePharmacy: boolean = true;
  SearchPharmacyList(str: any) {


    if (str && str.target.value && str.target.value?.length > 0) {
      if (str.keyCode == 40 || str.keyCode == 39 || str.keyCode == 38 || str.keyCode == 37) {
        this.isShowplaceholder = true;
        return false;
      }
      this.dNonePharmacy = false;
      this.isShowplaceholder = false;
      this.isLoading = true;
      this.filterSearchPharmaciesList = [];
      this.SearchPatientPharmacyModel.pharmacyTopRecord = '45';

      let search = str.target.value;
      if (/^\d+$/.test(search)) {
        this.SearchPatientPharmacyModel.pharmacyZip = search;
        this.SearchPatientPharmacyModel.pharmacyName = '';
      } else if (/^[a-zA-Z]+$/.test(search)) {
        if (this.ZIP) {
          this.SearchPatientPharmacyModel.pharmacyZip = this.ZIP
        }/*
        else if (this.practiceZip) {
          this.SearchPatientPharmacyModel.pharmacyZip = this.practiceZip
        }*/
        else {
          this.SearchPatientPharmacyModel.pharmacyZip = '';
        }

        this.SearchPatientPharmacyModel.pharmacyName = search;
      } else {
        this.SearchPatientPharmacyModel.pharmacyZip = '';
        this.SearchPatientPharmacyModel.pharmacyName = str.target.value;
      }
      //this.SearchPatientPharmacyModel.pharmacyZip='';
      if (/^\d+$/.test(search)) {
        this.SearchPatientPharmacyModel.pharmacyState = '';
        this.SearchPatientPharmacyModel.pharmacyCity = '';
      } else {
        if (this.STATE) {
          this.SearchPatientPharmacyModel.pharmacyState = this.STATE
        }/*
        else if (this.practiceState) {
          this.SearchPatientPharmacyModel.pharmacyState = this.practiceState
        }*/
        else {
          this.SearchPatientPharmacyModel.pharmacyState = '';
        }

        if (this.CITY) {
          this.SearchPatientPharmacyModel.pharmacyCity = this.CITY
        }/*
        else if (this.practiceCity) {
          this.SearchPatientPharmacyModel.pharmacyCity = this.practiceCity
        }*/
        else {
          this.SearchPatientPharmacyModel.pharmacyCity = '';
        }
      }
      this.SearchPatientPharmacyModel.patientAccount = this.PatientAccount;
      console.log("pharmacy request", this.SearchPatientPharmacyModel);
      this.UpdateinfoService.SearchPatientPharmacy(this.SearchPatientPharmacyModel).subscribe((res: any) => {
        this.isLoading = false;
        if (res.statusCode == 200) {
          this.filterSearchPharmaciesList = res.data;
          this.filterSearchPharmaciesList.map((res1: any) => {
            res1.pharmacyZip = this._phrutilService.maskingZipNum(res1.pharmacyZip);
            res1.pharmacyPhone = this._phrutilService.maskingPhoneNumer(res1.pharmacyPhone);
          })
        } else {
          this.isLoading = false;
          this.filterSearchPharmaciesList = [];

        }
      }, (error: any) => {

        this.isLoading = false;
        this.filterSearchPharmaciesList = [];

      })

    } else {
      this.dNonePharmacy = true;
      this.isLoading = false;
      this.filterSearchPharmaciesList = [];
    }
    return true;
  }
  RemovePharmacyData(num: any) {
    this.Getpharmacies.splice(num, 1);
    this.totalPharmacyRecord -= 1;
    this.AddUpdatePharmacy();
  }

  ValidateAddress(inputName: any) {
    let validaddres = inputName.value.replace(/[^/#.0-9a-zA-Z\s,-]/g, "");
    inputName.value = validaddres;
    this.pharmaciesSearch = validaddres
  }
  ObjPharmacy: any = {};
  AddUpdatePharmacy() {
    this.ObjPharmacy['practicE_CODE'] = this.PracticeCode;
    this.ObjPharmacy['patienT_ACCOUNT'] = this.PatientAccount;
    if (this.Getpharmacies?.length == 3) {
      localStorage.setItem("tpharmacy", "yes");
      this.ObjPharmacy['pharmacY_ID'] = this.Getpharmacies[0].PHARMACY_CODE.toString();
      this.ObjPharmacy['pharmacY2_ID'] = this.Getpharmacies[1].PHARMACY_CODE.toString();
      this.ObjPharmacy['pharmacY3_ID'] = this.Getpharmacies[2].PHARMACY_CODE.toString();
      console.log("length 3")
    } else if (this.Getpharmacies?.length == 2) {
      localStorage.setItem("tpharmacy", "yes");
      this.ObjPharmacy['pharmacY_ID'] = this.Getpharmacies[0].PHARMACY_CODE.toString();
      this.ObjPharmacy['pharmacY2_ID'] = this.Getpharmacies[1].PHARMACY_CODE.toString();
      this.ObjPharmacy['pharmacY3_ID'] = "";
      console.log("length 2")
    } else if (this.Getpharmacies.length == 1) {
      localStorage.setItem("tpharmacy", "yes");
      this.ObjPharmacy['pharmacY_ID'] = this.Getpharmacies[0].PHARMACY_CODE.toString();
      this.ObjPharmacy['pharmacY2_ID'] = "";
      this.ObjPharmacy['pharmacY3_ID'] = "";
      console.log("length 1")
    } else {
      localStorage.setItem("tpharmacy", "no");
      this.ObjPharmacy['pharmacY_ID'] = "";
      this.ObjPharmacy['pharmacY2_ID'] = "";
      this.ObjPharmacy['pharmacY3_ID'] = "";
    }
    // console.log("length ", this.Getpharmacies?.length)
    // console.log("saved pharmacy ",this.Getpharmacies);
    console.log("request pharmacy ", this.ObjPharmacy);
    //return 
    this.UpdateinfoService.AddUpdatePharmacy(this.ObjPharmacy).subscribe((res: any) => {

      if (res && res.statusCode == "200" && res.message == "Pharmacy updated successfully") {
        console.log("Pharmacy updated successfully");
        this.GetPatientPharmacies(this.PatientAccount, this.PracticeCode);
      }
    }, (error: any) => {
      console.log("unable to update Pharmacy");
    })
  }

  previewPhotos() {
    // this.previewUrls = [];
    for (let i = 0; i < this.photos.length; i++) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.previewUrls.push(e.target.result);
      };
      reader.readAsDataURL(this.photos[i]);
      this.isMedicatioListPhotoAdded = true;
      this.addNewMedication = false;
      this.addNewMedicationManually = false;
      console.log(this.previewUrls);
    }
  }

  openFileInput(index: number): void {
    const inputElement = document.getElementById('retakeMedicationList_' + index);
    if (inputElement) {
      this.renderer.selectRootElement(inputElement).click();
    }
  }
  retakePhoto(url: any, event: any): void {
    // Implement logic to retake the photo
    console.log('Retaking photo:', url);
    //const index = this.previewUrls.indexOf(url);
    const index = url;
    console.log(index);
    if (index !== -1) {
      this.previewUrls.splice(index, 1);
      this.uploadPhotoObj.splice(index, 1);
    }
    this.fileChangeEvent(event)
  }
  addPhotoInput() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.multiple = true;
    input.style.display = 'none';
    input.addEventListener('change', (event: any) => {
      //this.onFileChange(event);
      this.fileChangeEvent(event)
    });
    document.body.appendChild(input);
    input.click();
  }
  onModalMedication(operation: string, selectedOBJ?: any) {
    this.medicError = "";

    if (operation == this.operationEdit) {
      this.selected_objPatientMedication = { ...selectedOBJ };
      this.translateService.get('button.update').subscribe((translation: string) => {
        this.medicationaction = translation;
        this.addNewMedication = false;
        this.addNewMedicationManually = true;
        this.isMedicatioListPhotoAdded = false;
      });
      //this.medicationaction = "Update";
    } else {
      this.selected_objPatientMedication = new PatientMedicationModel();
      this.translateService.get('button.add').subscribe((translation: string) => {
        this.medicationaction = translation;
        this.addNewMedication = true;
        this.addNewMedicationManually = false;
        this.isMedicatioListPhotoAdded = false;
      });
      //this.medicationaction = "Add";
    }

    this.operationPerformed = operation;
    this.uploadPhotoObj = [];
    this.previewUrls = [];
    console.log(this.uploadPhotoObj);
    $("#Medical-History-Modal").modal("show");
  }
  AddMedicationManually() {
    this.addNewMedication = false;
    this.addNewMedicationManually = true;
    this.isMedicatioListPhotoAdded = false;
    this.filteredMedications = [];
    this.filteredDiagonosis = [];
  }
  onPatientMedication() {
    this.objPatientMedication = [];
    this.isLoadingPM = true;
    this.spinner.show();
    this._intakeMedicationService.GetPatientMedications(this.PracticeCode.toString(), this.PatientAccount.toString()).subscribe((res: any) => {

      this.spinner.hide();
      this.isLoadingPM = false;
      if (res.statusCode == 200) {
        this.objPatientMedication = res.data.getPatientMedicationsList as PatientMedicationModel[];
      } else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      }
      this.GetIntakeformFieldsSettings()
    },
      (error: any) => {
        this.spinner.hide();
        this.isLoadingPM = false;
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      });
  }
  onConfirmDeleteMedication() {
    this.spinner.show();
    if (!this.selected_objPatientMedication.patientPrescriptionId) {
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
      // this._phrutilService.showError("Service is not available, please try later.");
      this.spinner.hide();
      return;
    }

    let objDeleteMedication = new DeleteMedication();
    objDeleteMedication.patientPrescriptionId = this.selected_objPatientMedication.patientPrescriptionId;
    objDeleteMedication.practiceCode = this.PracticeCode.toString();
    objDeleteMedication.patientAccount = this.PatientAccount.toString();

    this._intakeMedicationService.DeletePatientMedication(objDeleteMedication).subscribe((res: any) => {
      $("#delete-medication").modal("hide")
      if (res.statusCode == 200) {
        this.GetNoKnownHistory();
        let text = "Medication is deleted successfully";
        this.translateService.get('Alerts.medication_deleted').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showSuccess(text);
        //this._phrutilService.showSuccess("Medication is deleted successfully");
        this.onPatientMedication();
      }
      else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      }
      this.spinner.hide();
    },
      (error: any) => {
        $("#delete-medication").modal("hide")
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
        this.spinner.hide();
      });

  }
  GetNoKnownHistory() {
    this._intakedAllergyService.GetNoKnownHistory(this.PatientAccount.toString(), this.PracticeCode.toString()).subscribe((res: any) => {

      if (res.statusCode == 200) {
        this.NoKnownHistory = res.data;
      }
    }, (error: any) => {

    });
  }
  isFromSaveMore: boolean = false;
  onlysaveMedication() {
    this.isFromSaveMore = false;
    this.OnMedicationSubmit();
  }
  AddanotherMedication() {
    this.isFromSaveMore = true;
    this.OnMedicationSubmit();
    this.selected_objPatientMedication.medicineName = "";
    this.selected_objPatientMedication.sig = "";
    this.selected_objPatientMedication.diagnosis = [];
    this.filteredMedications = [];
    this.filteredDiagonosis = [];
    //$("#addMore-medication").modal("hide");
  }
  CloseMedicationModal() {
    // this.onMedicationSave();
    $("#addMore-medication").modal("hide");
    $("#Medical-History-Modal").modal("hide");
  }
  OnMedicationSubmit() {
    if (this.addNewMedicationManually) {
      if (!this.selected_objPatientMedication.medicineName) {
        this.translateService.get('medication.medication_dropdown_error').subscribe((translation: string) => {
          this.medicError = translation;
        });

        //this.medicError = "Please select medications from search dropdown.";
        return;
      }

      if (!this.selected_objPatientMedication.medicineCode) {
        this.translateService.get('medication.medication_dropdown_error_correct').subscribe((translation: string) => {
          this.medicError = translation;
        });
        //this.medicError = "Please select correct medications from search dropdown.";
        return;
      }
    }
    //this.previewUrls = [];
    // $("#addMore-medication").modal("show");
    this.onMedicationSave();

  }

  onMedicationSave() {
    if (this.addNewMedicationManually) {
      let obj_Medication = new Medications();
      obj_Medication.medicineCode = this.selected_objPatientMedication.medicineCode;
      obj_Medication.medicineName = this.selected_objPatientMedication.medicineName;
      obj_Medication.diagCode = this.selected_objPatientMedication.diagCode;
      obj_Medication.ipAddress = this._IP_Address;
      obj_Medication.patientAccount = this.PatientAccount.toString();
      obj_Medication.practiceCode = this.PracticeCode.toString();
      obj_Medication.prescriptionId = this.selected_objPatientMedication.patientPrescriptionId;
      obj_Medication.sig = this.selected_objPatientMedication.sig;
      obj_Medication.unitCode = this.selected_objPatientMedication.unitCode;
      let lang = localStorage.getItem('language');
      if (!lang)
        lang = 'en';
      this.translateService.use(lang);
      obj_Medication.language = lang;
      this.spinner.show();
      this._intakeMedicationService.SavePatientMedications(obj_Medication).subscribe((res: any) => {
        this.spinner.hide();
        // $("#Medical-History-Modal").modal("hide");
        if (res.statusCode == 200) {
          if (this.operationPerformed == this.operationAdd) {
            let text = "Medications saved successfully";
            this.translateService.get('Alerts.medication_saved').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showSuccess(text);
            //this._phrutilService.showSuccess("Medications saved successfully");
          } else {
            let text = "Medications Updated successfully";
            this.translateService.get('Alerts.medication_updated').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showSuccess(text);
            //this._phrutilService.showSuccess("Medications Updated successfully");
          }
          if (this.isFromSaveMore) {
            this.onModalMedication('operationAdd');
            this.addNewMedicationManually = true;
            this.addNewMedication = false;
          } else {
            $("#Medical-History-Modal").modal("hide");
          }
          this.onPatientMedication();
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
      },
        (error: any) => {
          $("#Medical-History-Modal").modal("hide");
          this.spinner.hide();
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
      );
    } else {
      let obj_Medication = new MedicationsPhoto();
      obj_Medication.patientAccount = this.PatientAccount.toString();
      obj_Medication.practiceCode = this.PracticeCode.toString();
      this.spinner.show();
      console.log(this.uploadPhotoObj.length);
      for (let i = 0; i < this.uploadPhotoObj.length; i++) {
        setTimeout(() => {
          //this._intakeMedicationService.uploadAtFolder(this.uploadPhotoObj[i], "api/TalkCheckin/SaveMedicine_Photo", this.PatientAccount, this.PracticeCode).subscribe((res: any) => {
          this._intakeMedicationService.uploadAtFolder(this.uploadPhotoObj[i], "api/TalkCheckin/SaveMedicine_Photo_EHR", this.PatientAccount, this.PracticeCode).subscribe((res: any) => {
            this.spinner.hide();
            $("#Medical-History-Modal").modal("hide");
            if (res.statusCode == 200) {
              let text = "Your medication photo has been successfully uploaded. Your doctor will review and add it to your medication list shortly.";
              this.translateService.get('Alerts.medication_photo_saved').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showSuccess(text);
              this.onPatientMedication();
            }
            else {
              let text = "Service is not available, please try later.";
              this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showError(text);
              //this._phrutilService.showError("Service is not available, please try later.");
            }
          },
            (error: any) => {
              $("#Medical-History-Modal").modal("hide");
              this.spinner.hide();
              let text = "Service is not available, please try later.";
              this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showError(text);
              //this._phrutilService.showError("Service is not available, please try later.");
            }
          );

        }, 2000 * i); // 2000 milliseconds delay for each iteration
      }

    }



  }

  newDiagnosis: CommonDiseaseResponse | null;
  onChangeDisease(e: any): void {
    const selectedDisease = e.target.value;

    //console.log("Selected Disease:", selectedDisease);
    this.newDiagnosis = this.commonDisease.find(disease => disease.diseaseId === selectedDisease) || null;
    console.log(this.newDiagnosis);
    this.selected_objPatientMedication.diagnosis = this.newDiagnosis?.diseaseDescription;
    this.selected_objPatientMedication.diagCode = this.newDiagnosis?.icD10Code;
  }

  commonDisease: CommonDiseaseResponse[] = [];
  GetCommonDisease() {
    // this.isLoading = true;
    this.service.GetCommonDisease(this.PatientAccount.toString(), this.PracticeCode.toString(),).subscribe((res: any) => {
      console.log("res ", res);
      this.isLoading = false;
      this.commonDisease = res.data.commonDiseases as CommonDiseaseResponse[];
      console.log("common disease ", this.commonDisease);

    }, (error: any) => {
      console.log("Service error")
    });
  }

  filteredDiagonosis: any;
  SetDiagonosis(item: any) {
    if (item) {
      var all = objectCopyDiagnosis.filter((x: any) => x.ICD10_DESCRIPTION.toLowerCase() == item.toLowerCase());
      if (all != undefined && all != null && all.length > 0) {
        this.selected_objPatientMedication.diagnosis = all[0].ICD10_DESCRIPTION;
        this.selected_objPatientMedication.diagCode = all[0].ICD10_CODE;
      }
    }
  }
  dNonediagnosis: boolean = true;
  GetSolarApiDiagonsis(str: any) {

    if (str.keyCode == 40 || str.keyCode == 39 || str.keyCode == 38 || str.keyCode == 37) {
      return false;
    }

    if (this.selected_objPatientMedication.diagnosis == "" || this.selected_objPatientMedication.diagnosis.length <= 2) {
      this.selected_objPatientMedication.diagCode = "";
      this.filteredDiagonosis = [];
      this.dNonediagnosis = true;
      return false;
    }
    this.dNonediagnosis = false;
    this.isLoading = true;
    this._intakeMedicationService.GetSolarApiDiagonsis(this.selected_objPatientMedication.diagnosis, this.PatientAccount.toString(), this.PracticeCode.toString()).subscribe(
      (data: any) => {
        this.isLoading = false;
        if (data.numFound == "0") {
          this.filteredDiagonosis = data.docs;
        } else {
          this.filteredDiagonosis = data.docs;
          objectCopyDiagnosis = this.filteredDiagonosis;
        }
      })
    return true;
  }
  SetMedication(item: any) {
    if (item) {
      var all = objectCopyMedication.filter((x: any) => x.MEDICINE_TRADE.toLowerCase() == item.toLowerCase());
      if (all != undefined && all != null && all.length > 0) {
        this.selected_objPatientMedication.medicineCode = all[0].MEDICINE_CODE;
        this.selected_objPatientMedication.medicineName = all[0].MEDICINE_TRADE;
        this.selected_objPatientMedication.unitCode = all[0].UNIT_CODE;
      }
    }
  }

  SetMedicationForFD(item: any) {
    if (item) {
      var all = objectCopyMedication.filter((x: any) => x.medicine_trade.toLowerCase() == item.toLowerCase());
      if (all != undefined && all != null && all.length > 0) {
        this.selected_objPatientMedication.medicineCode = all[0].medicine_code;
        this.selected_objPatientMedication.medicineName = all[0].medicine_trade;
        this.selected_objPatientMedication.unitCode = "";
      }
    }
  }

  GetPatientMedicationFromFD(str: any) {
    const FDtoken = localStorage.getItem("medToken")

    if (FDtoken == null || FDtoken == undefined || FDtoken == "") {
      //return false
      this.isFDServiceDataComing = false;
      return this.GetSolarApiMedications(str);
    }

    this.isFDServiceDataComing = true;

    if (str.keyCode == 40 || str.keyCode == 39 || str.keyCode == 38 || str.keyCode == 37) {
      return false;
    }
    this.medicError = "";
    if (this.selected_objPatientMedication.medicineName == "" || this.selected_objPatientMedication.medicineName.length <= 2) {
      this.selected_objPatientMedication.medicineCode = "";
      this.filteredMedications = [];
      this.dNonemedication = true;
      return false
    }
    this.dNonemedication = false;
    const data: getMedication = new getMedication();
    data.Medicine_Name = this.selected_objPatientMedication.medicineName;
    data.Practice_code = this.PracticeCode;
    data.Provider_code = this.ProviderCode;
    this.isLoading = true;
    this._intakeMedicationService.GetPatientMedicationFromFD(data).subscribe((res: any) => {
      this.isLoading = false;
      //console.log(res);
      // this.filteredMedications = res.map((med:any) => med.medicine_trade);
      // Apply the convertToTitleCase method to each medication name
      this.filteredMedications = res.map((med: any) => {
        med.medicine_trade = this.convertFirstLetterCapital(med.medicine_trade);
        return med;
      });
      this.filteredMedications = res;
      objectCopyMedication = this.filteredMedications;
      // console.log(this.filteredMedications);
    })
    return true;
  }

  dNonemedication: boolean = true;
  GetSolarApiMedications(str: any) {
    if (str.keyCode == 40 || str.keyCode == 39 || str.keyCode == 38 || str.keyCode == 37) {
      return false;
    }
    this.medicError = "";
    if (this.selected_objPatientMedication.medicineName == "" || this.selected_objPatientMedication.medicineName.length <= 2) {
      this.selected_objPatientMedication.medicineCode = "";
      this.filteredMedications = [];
      this.dNonemedication = true;
      return false
    }
    this.dNonemedication = false;
    this.isLoading = true;
    this._intakeMedicationService.GetSolarApiMedications(this.selected_objPatientMedication.medicineName).subscribe(
      (data: any) => {
        this.isLoading = false;
        if (data.numFound == "0") {
          this.filteredMedications = data.docs;
        } else {

          this.filteredMedications = data.docs.map((med: any) => {
            med.MEDICINE_TRADE = this.convertFirstLetterCapital(med.MEDICINE_TRADE);
            //console.log("med.medicine_trade " + med.MEDICINE_TRADE);
            return med;
          });
          //data.docs = this.filteredMedications;
          //this.filteredMedications = data.docs;
          objectCopyMedication = this.filteredMedications;
        }
      })
    return true;
  }

  convertFirstLetterCapital(text: string): string {
    if (!text) return text;

    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }
  onDeleteMedication(selectedMedication: PatientMedicationModel) {

    this.selected_objPatientMedication = new PatientMedicationModel();
    this.selected_objPatientMedication = { ...selectedMedication };
    $("#delete-medication").modal("show");
  }
  noKnownDate: any;
  setNoKnownAlrgMedFam(type: any) {

    this.noKnownDate = '';

    if (type === 'medication') {

      if (this.NoKnownHistory[0].nO_KNOWN_MEDICATION === 'False' || this.NoKnownHistory[0].nO_KNOWN_MEDICATION == null || this.NoKnownHistory[0].nO_KNOWN_MEDICATION == undefined) {

        this.noKnownDate = 'Known Medication';
        this.SaveIntakeNoknownValues(2);
      }
      else {
        let text = "Medication is Already Set noKnown";
        this.translateService.get('Alerts.medication_already_setnoKnown').subscribe((translation: string) => {
          text = translation;
        });
        //this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo('Medication is Already Set noKnown');
        this._intakeser.onNoKnown();
      }
    }
  }
  SaveIntakeNoknownValues(type: any) {

    this.spinner.show();

    this._intakedAllergyService.SaveIntakeNoknownValues(type, this.PatientAccount, this.PracticeCode).subscribe((res: any) => {

      this.spinner.hide();

      if (res.statusCode == 200) {
        let text = "NoKnown Medication is set";
        this.translateService.get('Alerts.medication_setnoKnown').subscribe((translation: string) => {
          text = translation;
        });
        // this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo('NoKnown Medication is set');
        this._intakeser.onNoKnown();
      }
      else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      }
    }, (error: any) => {

      this.spinner.hide('intakeFormAllergy');
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
      //this._phrutilService.showError("Service is not available, please try later.");

    });
  }
  onModalMedicationProvider(data: any) {
    if (data == 'edit') {
      let text = "You can't edit medication added by provider";
      this.translateService.get('Alerts.medication_cannot_edit_by_provider').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showInfo(text);
      // this._phrutilService.showInfo("You can't edit medication added by provider");
    }
    else if (data == 'delete') {
      let text = "You can't delete medication added by provider";
      this.translateService.get('Alerts.medication_cannot_delete_by_provider').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showInfo(text);
      //this._phrutilService.showInfo("You can't delete medication added by provider");
    }
  }
  GetIntakeformFieldsSettings() {

    this.intakeFieldsSetting = this._phrutilService.decrypt(localStorage.getItem("intakeformsetting"));
  }
  //add photo of medicatio list
  fileChangeEvent(event: any) {

    let info = localStorage.getItem('PersonalInfo');
    if (!info) {
      return;
    }
    this.patientpersonalinfo = this._phrutilService.decrypt(info);

    var mimeType = event.target.files[0].type;
    var file = event.target.files[0].file;
    if (mimeType.match(/image\/*/) == null) {
      let text = "Only images are supported.";
      this.translateService.get('Alerts.only_images_are_supported').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
      // this._phrutilService.showError("Error", "Only images are supported.");
      this.imageChangedEvent = undefined;
      this.isMedicatioListPhotoAdded = false;
      this.addNewMedication = true;
      return;
    }
    var filename = event.currentTarget.value.toLowerCase();
    let ext = this.getFileExtension(filename);
    if (ext != 'png' && ext != 'jpg' && ext != 'jpeg' && ext != 'gif') {
      let text = "File format is invalid!. Please select jpg, jpeg, png or gif file.";
      this.translateService.get('Alerts.file_format_invalid').subscribe((translation: string) => {
        text = translation;
      });
      this._phrutilService.showError(text);
      //this._phrutilService.showError("Error", "File format is invalid!. Please select jpg, jpeg, png or gif file.");
      event = "";
      this.imageChangedEvent = undefined;
      this.isMedicatioListPhotoAdded = false;
      this.addNewMedication = true;
      return;
    }

    this.imageChangedEvent = event.target.files[0];
    this.uploadPhotoObj.push(event.target.files[0]);
    console.log(this.imageChangedEvent);
    console.log(this.uploadPhotoObj);
    //this.isDefaultImage = false;

    //this.spinner.show();
    //this.showPreview(event);
    this.photos = event.target.files;
    this.previewPhotos();
  }
  //show local image
  defaultImage: any;
  isMedicatioListPhotoAdded: boolean = false;

  showPreview(event: Event) {
    let selectedFile = (event.target as HTMLInputElement).files?.item(0)

    if (selectedFile) {
      if (["image/jpeg", "image/png", "image/svg+xml", "image/gif"].includes(selectedFile.type)) {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(selectedFile);

        fileReader.addEventListener('load', (event) => {
          this.defaultImage = event.target?.result;
          console.log(this.defaultImage);
          this.isMedicatioListPhotoAdded = true;
          this.addNewMedication = false;
          this.addNewMedicationManually = false;
          //this.isImageSelected = true
        })
      }
    } else {
      //this.isImageSelected = false
    }
  }

  getFileExtension(fileName: any) {
    return fileName.toLowerCase().split('.').pop();
  }
  goBackToAddMedication() {
    this.addNewMedicationManually = false;
    this.addNewMedication = true;
    this.isMedicatioListPhotoAdded = false;
    this.uploadPhotoObj = [];
    this.previewUrls = [];
  }
}
